// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store"; // Adjust the import based on your file structure
import { InitializeVoucherStripePaymentData } from "../../api/types";
import Logger from "../helpers/logger";
import ErrorTracker from "../helpers/errorTracker";
import { stripePaymentInitialized } from "../slice/bookingCreation/bookingCreationSlice";
import { notifyActionableBookingFailure } from "../helpers/failureNotification";
import { buildAppUrl } from "../../util";

import { useInitializeVoucherStripePaymentMutation } from "../../api/payments/paymentsApiSlice";

export const useInitializeVoucherStripePayment = () => {
  const voucherAmount = useSelector((state: RootState) =>
    state.bookingCreation.voucherAmount
  );

  const contact = useSelector(
    (state: RootState) => state.bookingCreation.personalData
  );

  const [initializeVoucherStripePaymentMutation] =
    useInitializeVoucherStripePaymentMutation();

  const dispatch = useDispatch();

  const initializeStripePayment = async () => {
    try {
      if (voucherAmount && contact) {
        const returnUrl = buildAppUrl(`/vouchers/payment/stripe/return`);

        const payload: InitializeVoucherStripePaymentData = {
          firstName: contact.firstName,
          lastName: contact.lastName,
          email: contact.email,
          voucherAmount: voucherAmount,
          returnUrl,
          cancelUrl: buildAppUrl("/payments/stripe/return"),
        };

        const response = await initializeVoucherStripePaymentMutation(
          payload
        ).unwrap();

        if (response) {
          dispatch(stripePaymentInitialized(response));
        }

        return response;
      }
    } catch (error) {
      Logger.for("Initialize Payment for Voucher").error(error);
      ErrorTracker.trackException(error as Error);
      // VoucherPaymentStep renders the persistent failure panel; add the
      // reason only when it is one the customer can act on (#1970).
      notifyActionableBookingFailure(dispatch, error);
    }
  };

  return initializeStripePayment;
};
